<template>
  <div style="padding: 10px">
    <el-row class="box2">
      <el-col :span="8">申请状态：{{ formData.status_name }}</el-col>
      <el-col :span="8">退料个人库：{{ formData.from_store_name }}</el-col>
      <el-col :span="8">目标总库：{{ formData.to_store_name }}</el-col>
    </el-row>
    <el-row class="box2">
      <el-col :span="8">申请时间：{{ formData.create_time }}</el-col>
      <el-col :span="16">申请备注：{{ formData.remark }}</el-col>
    </el-row>

    <template v-if="bySn">
      <el-row class="box">
        <el-col :span="4" style="text-align:left">物料编码</el-col>
        <el-col :span="6" style="text-align:left">物料名称</el-col>
        <el-col :span="3">回料数量</el-col>
        <el-col :span="3">回料申请SN</el-col>
        <el-col :span="4" style="text-align: center">退入库位</el-col>
        <el-col :span="4" style="text-align: center">接收SN</el-col>
      </el-row>

      <div style="height:290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in formData.item_list" :key="item.id" class="row" :gutter="15">
          <el-col :span="4">{{ item.material_code }}</el-col>
          <el-col :span="6">{{ item.material_name }}</el-col>
          <el-col :span="3">{{ item.request_cnt }}</el-col>
          <el-col :span="3">{{ item.return_sn }}</el-col>
          <el-col :span="4">
            <el-select v-model="item.location_id" class="form-item" placeholder="退入库位" clearable style="width: 100%">
              <el-option v-for="location in formData.location_list" :key="location.id" :label="location.code" :value="location.id"></el-option>
            </el-select>
          </el-col>
          <el-col :span="4">
            <el-input v-model.trim="item.receive_sn" placeholder="接收SN" style="width: 100%"></el-input>
          </el-col>
        </el-row>
      </div>
    </template>
    <template v-else>
      <el-row class="box">
        <el-col :span="6" style="text-align:left">物料编码</el-col>
        <el-col :span="10" style="text-align:left">物料名称</el-col>
        <el-col :span="3">回料数量</el-col>
        <el-col :span="5">退入库位</el-col>
      </el-row>

      <div style="height:290px;overflow-y: auto;overflow-x: hidden">
        <el-row v-for="item in formData.item_list" :key="item.id" class="row" :gutter="15">
          <el-col :span="6">{{ item.material_code }}</el-col>
          <el-col :span="10">{{ item.material_name }}</el-col>
          <el-col :span="3">{{ item.request_cnt }}</el-col>
          <el-col :span="5">
            <el-select v-model="item.location_id" class="form-item" placeholder="退入库位" clearable style="width: 100%">
              <el-option v-for="location in formData.location_list" :key="location.id" :label="location.code" :value="location.id"></el-option>
            </el-select>
          </el-col>
        </el-row>
      </div>
    </template>


    <el-row style="margin-top: 15px">
      <el-col :span="24">
        <el-input type="textarea" class="quote-remark" v-model="formData.approval_remark" placeholder="审核备注" style="width: 100%" :autosize="true"></el-input>
      </el-col>
    </el-row>

    <el-form-item>
      <el-button type="primary" style="width: 150px;margin-top: 20px" @click="agreeRequest" :disabled="formData.status != 'wait_approval'" :loading="loading">接收退料</el-button>
      <el-button type="primary" style="width: 150px;;margin-top: 20px" @click="rejectRequest" :disabled="formData.status != 'wait_approval'" :loading="loading">否决申请</el-button>
    </el-form-item>

  </div>
</template>

<script>
export default {
  name: "ApprovalReturnRequest",
  inject: ['$fn'],
  props: {
    params: {
      type: Object,
      default: () => {
        return {}
      }
    },
    parentData: {
      type: Object,
      default: () => {
        return {}
      }
    },
    setting: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      formData: {
        request_id: '',
        create_user_name: '',
        create_time: '',
        status_name: '',
        status: '',
        item_list: [],
        location_list: [],
      },
      loading: false
    }
  },
  computed: {
    bySn() {
      return this.formData.item_list.length > 0 && this.formData.item_list[0].return_sn
    }
  },
  created() {
    this.getInfo();
  },
  methods: {
    getInfo() {
      var requestId = this.parentData.id;
      this.$axios.get('wms/request/return/getInfo?requestId=' + requestId).then(response => {
        let res = response.data
        if (res.code != 0) {
          return this.$message.error("获取明细列表失败");
        }

        this.formData = res.data;
      }, error => {
        this.$message.error(`获取失败，${error.message}`);
      })
    },
    agreeRequest() {
      for (let i = 0; i < this.formData.item_list.length; i++) {
        let obj = this.formData.item_list[i]
        if (!obj.location_id || obj.location_id == '') {
          return this.$message.error("未输入库位");
        }

        if (this.bySn && obj.return_sn?.trim() !== obj.receive_sn) {
          return this.$message.error(`第${i + 1}行，接收的SN与回料SN不一致`);
        }
      }

      this.loading = true;
      this.$axios.post('wms/request/return/agree', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`提交失败，${res.message}`);
        }

        this.$message.success("提交成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.formData.status = '';
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    },
    rejectRequest() {
      this.loading = true;
      this.$axios.post('wms/request/return/reject', this.formData).then(response => {
        this.loading = false;
        let res = response.data
        if (res.code != 0) {
          return this.$message.error(`提交失败，${res.message}`);
        }

        this.$message.success("提交成功");
        this.$fn.closeWindow();
        this.$fn.search();
        this.formData.status = '';
      }, error => {
        this.loading = false;
        this.$message.error(`提交失败，${error.message}`);
      })
    }
  }
}
</script>

<style scoped>
.form-item {
  width: 240px;
}

.product-head {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  margin-top: 15px;
}

.product-head span {
  margin-left: 50px;
}

.box {
  background-color: lightgray;
  height: 35px;
  line-height: 35px;
  text-align: left;
}

.box2 {
  height: 35px;
  line-height: 35px;
  text-align: left;
}

.row {
  margin-top: 15px;
  padding: 0;
}

.row .tip {
  color: goldenrod;
  text-align: center;
  font-size: 14px;
}

.w-percent-90 {
  width: 90%;
}

.w100 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.tax-amount {
  color: red;
  font-size: 18px;
}

.tax-amount span {
  margin-left: 15px;
}

.quote-remark {
  width: 100%;
  padding-right: 15px;
}

.close {
  position: absolute;
  top: 5px;
  right: 18px;
  font-size: 18px;
  cursor: pointer;
}
</style>